import React from 'react';
import {styleForHeader} from '../../style.js';

export const GridColumns = [
    { field: 'id', hide: true},
    { 
        field: 'processTypeName', width: 250, headerAlign: 'center', align:'center', text:'SÜREÇ TÜR ADI',
        renderHeader: () => styleForHeader('SÜREÇ TÜR ADI')
    },    
    { field: 'processGroup',width: 250, headerAlign: 'center', align:'center', type:'singleSelect', labelText:'Grup Adı', text:'SÜREÇ GRUP ADI',
      renderHeader: () => styleForHeader('SÜREÇ GRUP ADI'),            
      renderCell: (params) => (<div>{params.value.name}</div>),
      dataList:[],
      keyField:'id',valueField:'name'
    }
];